<script setup lang="ts">
import { type HTMLAttributes, computed } from 'vue';

import {
  DropdownMenuItem,
  type DropdownMenuItemProps,
  useForwardProps
} from 'radix-vue';

import { cn } from '@/lib/utils';
import { createDelegatedProps } from '@/lib/helpers';

const props = withDefaults(defineProps<
  DropdownMenuItemProps & {
    class?: HTMLAttributes['class'];
    inset?: boolean;
    testId?: string;
  }
>(), {
  testId: "dropdown-menu"
});

const delegatedProps = computed(() =>
  createDelegatedProps<typeof props>(props)
);

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
  <DropdownMenuItem
    v-bind="forwardedProps"
    :data-testid="`${props.testId}-item`"
    :class="
      cn(
        'relative flex cursor-default select-none items-center rounded-md px-3 py-1 text-sm font-medium outline-none transition-colors hover:bg-blue-50 hover:cursor-pointer focus:outline-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50',
        inset && 'pl-8',
        props.class
      )
    "
  >
    <slot />
  </DropdownMenuItem>
</template>
